import { getValidAccessToken } from '@/lib/supabase/getValidAccessToken';
import UserService, { type UserProfile } from '@/lib/UserService';
import { atom } from 'nanostores';

export const $userProfile = atom< UserProfile | null >( null );

/**
 * Loads the member profile into `$userProfile`. Called by the central
 * auth-init module after session restore (`INITIAL_SESSION` / `SIGNED_IN`).
 * Failures are caught: `$userProfile` stays null and dependent UI degrades
 * gracefully; the profile route performs its own fetch with error handling.
 */
export const loadUserProfile = async (): Promise< void > => {
	try {
		const result = await getValidAccessToken();
		if ( result.status !== 'ok' ) return;
		const userService = new UserService();
		$userProfile.set( await userService.getUserProfile( result.token ) );
	} catch {
		// Keep $userProfile null; no unhandled rejection.
	}
};

export const formatUserName = ( profile: UserProfile | null ) => {
	if ( ! profile ) return '';

	return profile.Vorname || profile.Name
		? profile.Vorname + ' ' + profile.Name
		: profile.Email;
};
